import { useAuth } from "auth/use-auth";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from 'react-router-dom';

import { queryUserSettings } from "api/query/query-user-settings";

import { UserHeader } from "views/user/components/user-header/user-header";

import { GravatarProfile } from 'views/user/settings/components/gravatar-profile/gravatar-profile';
import { GravatarQuickEdit } from 'views/user/settings/components/gravatar-quick-edit/gravatar-quick-edit';
import { SetUsername } from 'views/user/settings/components/set-username/set-username';

export const loader =
  ({ queryClient, user }) =>
  async ({ params }) => {
    if (!user) {
      return null;
    }

    const query = queryUserSettings({ user });

    return queryClient.ensureQueryData(query);
  };

export const Settings = () => {
  const { user } = useAuth();
  const { data } = useQuery(queryUserSettings({ user }));
  const navigate = useNavigate();

  if (!user || !data) {
    return navigate('/');
  }

  return (
    <>
      <UserHeader user={data} />
      <SetUsername user={data} />
      <GravatarQuickEdit />
      <GravatarProfile />
    </>
  );
};
